export const currentOrigin = () =>
  typeof window === 'undefined' ? '' : window.location.origin;
